import { createContext, type ReactNode } from 'react';
import { stores, type RootStore } from '@/stores';

export const StoreContext = createContext<RootStore>(stores);

export function StoreProvider({ children }: { children: ReactNode }) {
  return <StoreContext.Provider value={stores}>{children}</StoreContext.Provider>;
}
